import { form as formify } from 'formifier';
import logRAID from '../logRAID';
import logPardotVisitor from '../logPardotVisitor';
import logOptimizelyVariantIds from '../logOptimizelyVariantIds';
import { persistFieldValueInSession } from '../util/sessionUtilities';
import { EmployeeCountValidator } from './employeeCountValidator';
import executeRecaptchaIfPresent from '../util/googleRecaptcha';
import { Application } from 'stimulus';
import FormController from '../controllers/smart_dollar_basic_info_form.controller';

const logVisit = () => {
  logRAID();
  logPardotVisitor();
  logOptimizelyVariantIds();
};

const persistFieldValues = (formElement) => {
  persistFieldValueInSession(
    formElement.querySelector('#email'),
    'session_email'
  );

  persistFieldValueInSession(
    formElement.querySelector('#lead_form_url'),
    'session_initial_form_url'
  );
};

const setupFormifier = (formElement, submitCallback) => {
  /* eslint-disable camelcase */
  const formifierErrorMessages = {
    first_name: {
      valueMissing: 'Please enter your first name.',
      patternMismatch: 'Please enter your first name.',
      tooLong: 'Please enter 40 characters or less for your first name.'
    },
    last_name: {
      valueMissing: 'Please enter your last name.',
      patternMismatch: 'Please enter your last name.',
      tooLong: 'Please enter 80 characters or less for your last name.'
    },
    user_company_name: {
      valueMissing: 'Please enter the name of your business.',
      patternMismatch: 'Please enter the name of your business.',
      tooLong: 'Please enter 100 characters or less for the name of your business.'
    },
    email: {
      valueMissing: 'Please enter your business email address.',
      patternMismatch: 'Please enter a valid email address.',
      typeMismatch: 'Please enter a valid email address.',
      tooLong: 'Please enter 80 characters or less for your business email address.'
    },
    phone: {
      valueMissing: 'Please enter your phone number.',
      patternMismatch: 'Please enter a valid 10-digit phone number.',
      tooLong: 'Please enter 14 characters or less for your phone number.'
    },
    user_employee_count: {
      valueMissing: 'Please enter the total number of employees.',
      rangeUnderflow: 'Please enter a number between 0 and 99999999.',
      rangeOverflow: 'Please enter a number between 0 and 99999999.'
    },
    user_reported_lead_source: {
      valueMissing: 'Please make a selection.'
    },
    user_reported_lead_source_other_detail: {
      valueMissing: 'Please tell us how you heard about SmartDollar.',
    },
    user_reported_lead_source_live_detail: {
      valueMissing: 'Please tell us which live event/conference you attended.',
    },
    referred_by: {
      valueMissing: 'Please tell us who referred you.',
      patternMismatch: 'Please tell us who referred you.',
      tooLong: 'Please enter 100 characters or less for this field.'
    },
  };

  formify(formifierErrorMessages, formElement, submitCallback);
};

const startStimulus = () => {
  const application = Application.start();
  application.register("formController", FormController);
};

export default function initializeForm() {
  const smartdollarBasicInfoForm = document.querySelector(
    'form[data-component-id="smartdollarBasicInfoForm"]'
  );

  if (!smartdollarBasicInfoForm) {
    return;
  }

  new EmployeeCountValidator().setup();
  
  persistFieldValues(smartdollarBasicInfoForm);
  logVisit();
  setupFormifier(smartdollarBasicInfoForm, () => executeRecaptchaIfPresent(smartdollarBasicInfoForm));
  startStimulus();
}

window.addEventListener('load', initializeForm);
